import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TokenStoreService {
  private readonly refreshTokenKey = 'PasuraRefreshToken';
  private jwtToken = '';

  getJwtToken(): string {
    return this.jwtToken;
  }

  setJwtToken(token: string): void {
    this.jwtToken = token ?? '';
  }

  clearJwtToken(): void {
    this.jwtToken = '';
  }

  getRefreshToken(): string | null {
    return sessionStorage.getItem(this.refreshTokenKey);
  }

  setRefreshToken(token: string): void {
    sessionStorage.setItem(this.refreshTokenKey, token);
  }

  clearRefreshToken(): void {
    sessionStorage.removeItem(this.refreshTokenKey);
  }
}
